import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function AdminRoute({ children }) {
  const { currentUser, isAdmin, loading } = useAuth();
  
  // Still loading auth state
  if (loading) {
    return <div>Loading...</div>;
  }
  
  // Not logged in at all
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  // Logged in but not admin
  if (!isAdmin) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '50vh',
        padding: '20px'
      }}>
        <h2>Access Denied</h2>
        <p>You need administrator privileges to access this page.</p>
        <button 
          onClick={() => window.history.back()}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Go Back
        </button>
      </div>
    );
  }
  
  // Is admin - allow access
  return children;
}

export default AdminRoute;